import { render, staticRenderFns } from "./note_author.vue?vue&type=template&id=c386cc6e"
import script from "./note_author.vue?vue&type=script&lang=js"
export * from "./note_author.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports